var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"post",class:_vm.$style.section,attrs:{"data-post-id":_vm.postId}},[_c('v-post-header',{attrs:{"post":_vm.post}}),_c('v-post-preview',{attrs:{"post":_vm.post,"is-footer":""}}),_c('v-post-footer',{attrs:{"post":_vm.post}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }